<ion-content [fullscreen]="true" *ngIf="provider$ | async as provider">

  <app-header [provider]="provider"></app-header>

  <ng-container *ngIf="service$ | async as field">

    <div class="content nopadding">
      <div class="kategorija mt-30">
        <h1>{{ field?.name }}</h1>

        <ng-container *ngFor="let category of field?.children">
          <div [routerLink]="['/', field.slug, category.slug]"   class="item clickable" *ngIf="category.visibleForCustomers" >
            <img [src]="(category?.avatar?.url) ? (category?.avatar?.url ) : ('/assets/img/category_4.png')" alt="{{field?.name}} - {{category?.name}} | dm Studio"><b>{{category?.name}}</b>
          </div>
        </ng-container>
      </div>
    </div>


    <div class="content nopadding">
        <app-relevant></app-relevant>
    </div>

  </ng-container>

  <app-footer [provider]="provider"></app-footer>

  <app-cart [provider]="provider"></app-cart>

</ion-content>
